import { CheckCircle, Circle, Truck, Package } from "@phosphor-icons/react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const statusColor = (s) => {
  if (s === "Delivered") return "text-green-500";
  if (s === "In Transit") return "text-signal";
  return "text-neutral-400";
};

export default function TrackingTimeline({ shipment }) {
  if (!shipment) return null;
  const events = [...(shipment.events || [])].reverse();
  return (
    <div data-testid="tracking-result" className="bg-white border-2 border-obsidian shadow-brutal">
      <div className="bg-obsidian text-stark p-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="font-mono text-xs text-neutral-400 tracking-widest uppercase">Tracking No.</p>
          <p className="font-mono text-2xl tracking-widest text-signal" data-testid="result-tracking-number">
            {shipment.tracking_number}
          </p>
        </div>
        <div className="text-right">
          <p className="font-mono text-xs text-neutral-400 tracking-widest uppercase">Status</p>
          <p className={`font-display font-semibold text-xl ${statusColor(shipment.status)}`}>{shipment.status}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 border-b border-neutral-200">
        {[
          ["From", shipment.origin],
          ["To", shipment.destination],
          ["Service", shipment.service_type],
          ["ETA", shipment.eta || "—"],
        ].map(([k, v]) => (
          <div key={k} className="p-4 border-r border-neutral-200 last:border-r-0">
            <p className="font-mono text-[10px] text-neutral-400 tracking-widest uppercase">{k}</p>
            <p className="font-sans font-medium text-obsidian mt-1">{v}</p>
          </div>
        ))}
      </div>

      <div className="p-6">
        <div className="relative pl-8">
          <div className="absolute left-[7px] top-2 bottom-2 w-0.5 bg-neutral-200" />
          {events.map((e, i) => {
            const active = i === 0;
            const Icon = e.status === "Delivered" ? CheckCircle : active ? Truck : Package;
            return (
              <div key={i} className="relative pb-8 last:pb-0" data-testid={`timeline-event-${i}`}>
                <span
                  className={`absolute -left-8 top-0 bg-white ${active ? "text-signal" : "text-neutral-400"}`}
                >
                  {active ? <Icon weight="fill" size={18} /> : <Circle weight="fill" size={16} />}
                </span>
                <p className={`font-sans font-semibold ${active ? "text-obsidian" : "text-neutral-600"}`}>
                  {e.status} · <span className="font-normal text-neutral-500">{e.location}</span>
                </p>
                <p className="text-sm text-neutral-500 mt-0.5">{e.description}</p>
                <p className="font-mono text-[11px] text-neutral-400 mt-1">
                  {new Date(e.timestamp).toLocaleString()}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {shipment.pod_images?.length > 0 && (
        <div className="border-t border-neutral-200 p-6" data-testid="pod-gallery">
          <p className="font-mono text-xs tracking-widest uppercase text-signal mb-4">Proof of Delivery</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {shipment.pod_images.map((p) => (
              <a key={p.file_id} href={`${BACKEND}${p.url}`} target="_blank" rel="noopener noreferrer"
                className="block border-2 border-obsidian overflow-hidden group">
                <img src={`${BACKEND}${p.url}`} alt={p.original_filename}
                  className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-500" />
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
